import { createAsyncThunk } from "@reduxjs/toolkit";
import { BankApi } from "api/bank";
import { ResponseEnum } from "enums/response";
import { PlayerBankFormType } from "types/bank";

export const getListBank = createAsyncThunk(
  "bank/getListBank",
  async (username: string, { rejectWithValue }) => {
    try {
      const dataListBank = await BankApi.getListBank(username);
      return dataListBank;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListPlayerBank = createAsyncThunk(
  "bank/getListPlayerBank",
  async (username: string, { rejectWithValue }) => {
    try {
      const dataListPlayerBank = await BankApi.getListPlayerBank(username);
      return dataListPlayerBank;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addPlayerBank = createAsyncThunk(
  "bank/addPlayerBank",
  async (formData: PlayerBankFormType, thunkApi) => {
    try {
      const response = await BankApi.addPlayerBank(formData.username, formData);

      if (response.status !== ResponseEnum.statusSuccess) return;
      const { dispatch } = thunkApi;
      dispatch(getListPlayerBank(formData.username));

      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
